export const PERSON_LEGALTYPE_BUSINESS = 'BUSINESS';
export const PERSON_LEGALTYPE_INDIVIDUAL = 'INDIVIDUAL';
